import React, { Fragment } from 'react';
import { Box, Typography } from '@mui/material';
import { ArrayInput, BooleanInput, FormDataConsumer, SelectInput, SimpleFormIterator, TimeInput, required } from 'react-admin';
import DateTimeInputUTC from '../../../components/DateTimeInputUTC';
import { daysOfTheWeek, frequencyChoices } from '../../../constants';

const dailyContainerSx = {
  display: 'flex',
  gap: '30px',
  marginBottom: '20px'
};

const dateTimePickerSx = {
  display: 'flex',
  gap: '20px',
};

const inputWrapperSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  margin: '0 0 20px 0',
};

const inputSx = {
  margin: '0 20px 0 0',
};

const daySx = {
  fontSize: 16,
  margin: '20px 0'
};

const FormScheduleDiscount = () => {

  return (
    <>
      <BooleanInput source="isSchedule" label="Ativar agendamento" defaultValue={false} />
      <FormDataConsumer>
        {({ formData }) => (
          <>
            <Box sx={dateTimePickerSx}>
              <DateTimeInputUTC
                source="startAt"
                label="Data inicial"
                disabled={!formData.isSchedule}
                validate={formData.isSchedule ? [required()] : []}
              />
              <DateTimeInputUTC
                source="endAt"
                label="Data final"
                disabled={!formData.isSchedule}
                validate={formData.isSchedule ? [required()] : []}
              />
            </Box>
            <SelectInput
              label="Frequência"
              source="frequency"
              alwaysOn
              style={{ marginTop: 10 }}
              choices={frequencyChoices}
              // onChange={({ target: { value } }) => setFrequency(value)}
              disabled={!formData.isSchedule}
              validate={formData.isSchedule ? [required()] : []}
            />
          </>
        )}
      </FormDataConsumer>
      <FormDataConsumer>
        {({ formData }) => {

          if (!formData.isSchedule) {
            return <></>;
          }

          if (formData.frequency === 'daily') {
            return (
              <Box sx={dailyContainerSx}>
                <TimeInput
                  source="startTime"
                  label="Horário inicial"
                  style={{ width: 200 }}
                  isRequired
                  validate={[required()]}
                />
                <TimeInput
                  source="endTime"
                  label="Horário final"
                  style={{ width: 200 }}
                  isRequired
                  validate={[required()]}
                />
              </Box>
            );
          };

          if (formData.frequency === 'weekly') {
            return (
              <ArrayInput source="weekSchedual" label="Defina os dias e horários">
                <SimpleFormIterator disableAdd disableRemove disableReordering >
                  <FormDataConsumer>
                    {({ scopedFormData }) => {
                      if (!scopedFormData) { return <></>; }

                      const day = daysOfTheWeek.find(wd => wd.id === scopedFormData.dayOfTheWeek);
                      return (
                        <>
                          <Typography sx={daySx}>{day?.name}</Typography>
                          <Box sx={inputWrapperSx}>
                            <BooleanInput
                              source="isActive"
                              label={false}
                              sx={inputSx}
                            />
                            {scopedFormData && scopedFormData.isActive &&
                              <Fragment>
                                <TimeInput
                                  label='Horário inicial'
                                  source="startTime"
                                  style={{ marginRight: 20, width: 200 }}
                                  isRequired
                                />
                                <TimeInput
                                  label='Horário final'
                                  source="endTime"
                                  style={{ marginRight: 20, width: 200 }}
                                  isRequired
                                />
                              </Fragment>
                            }
                          </Box>
                        </>
                      );
                    }}
                  </FormDataConsumer>
                </SimpleFormIterator>
              </ArrayInput>
            );
          }
        }}
      </FormDataConsumer>
    </>
  );
};

export default React.memo(FormScheduleDiscount);